import type { FC } from 'react';

import { useGetAllOwnPosts } from '@/features/api/hooks/grapevine-post/useGetAllOwnPosts';
import { SimplePostList } from '@/features/posts/components/SimplePostList';
import { SIZE } from '@/features/posts/constants/params';

export const OwnPostsScreen: FC = () => {
  const {
    data: posts,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
    isRefetching
  } = useGetAllOwnPosts({
    count: SIZE
  });

  return (
    <SimplePostList
      posts={posts}
      isLoading={isLoading}
      isError={isError}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      refetch={refetch}
      isRefetching={isRefetching}
      hideEndView
    />
  );
};
